export enum TypeEnum {
  Purchase = 1,
  Selling = 2,
  Repair = 3,
  Dispose = 4,
}
